module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Introduction and Compilation Copyright © 2016 by The Omidi Company LLC")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Cats on Instagram")]), _vm._v(" and @cats_of_instagram are operated independently and are not affiliated with, endorsed, or sponsored by Instagram LLC. All photographs copyright © by the individual photographers.")]), _vm._v(" "), _c('p', [_vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', [_vm._v("Library of Congress Cataloging-in-Publication Data available.")]), _vm._v(" "), _c('p', [_vm._v("ISBN 978-1-4521-5196-0 (hc)")]), _vm._v(" "), _c('p', [_vm._v("ISBN 987-1-4521-5281-3 (epub, mobi)")]), _vm._v(" "), _c('p', [_vm._v("Design by Hillary Caudle")]), _vm._v(" "), _c('p', [_vm._v("Front jacket photographs by: @juiceecat, @alain_cat, @polagram, @precious_luna, @wednesdayandgizmo, @threescaredycats, @whiskered_away, @cheddarcheesepuff, @jesyalmaguer, @panchobear, @momomilochub, @henrynoodle, @s_nookie, @mspollypockets, @veronicagrojano, @meowscott, @musammmmm")]), _vm._v(" "), _c('p', [_vm._v("Back jacket photographs by: @themaestros, @summer_dawn_ adams, @macchacat, @bagwellphotography, @playground_ ragdolls, @exoticniko, @yeonhoo_doma, @anniepaddington, @chippydiego, @molla_and_bozley, @nala_cat")]), _vm._v(" "), _c('p', [_vm._v("Chronicle Books LLC"), _c('br'), _vm._v("680 Second Street"), _c('br'), _vm._v("San Francisco, CA 94107"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("www.chroniclebooks.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-992f161e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05copyright.vue
// module id = 69
// module chunks = 0